import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

function TriangleDown(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox="0 0 8.982 7.859" fontSize={'inherit'} {...props}>
      <path
        id="Polygone_3"
        data-name="Polygone 3"
        d="M4.491,0,8.982,7.859H0Z"
        transform="translate(8.982 7.859) rotate(180)"
        fill="#333"
      />
    </SvgIcon>
  );
}

export default TriangleDown;
